import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { communicationsStatusPagePreviewRoute } from '@atlassian/jira-router-routes-communications-routes/src/communicationsStatusPagePreviewRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { StatusPagePreviewPageEntryPoint } from './ui/status-page-preview/StatusPagePreviewPageEntryPoint.tsx';

export const communicationsStatusPagePreviewRouteEntry = createEntry(
	communicationsStatusPagePreviewRoute,
	() => ({
		group: 'communications',

		navigation: {
			menuId: MENU_ID.STATUS_PAGE_MANAGE,
		},

		entryPoint: () => {
			return fg('communications_status_page_manage_preview')
				? StatusPagePreviewPageEntryPoint
				: undefined;
		},

		resources: [...getNavigationResources()],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-communications-entries/src/communicationsStatusPagePreviewRouteEntry.tsx',
				whichExportToUse: 'communicationsStatusPagePreviewRouteEntry',
			},
			enabled: true,
		},
	}),
);
